import useSWR from "swr";
import { getLibraryMediaUrl, type LibraryMediaUrl } from "@/lib/api";

export function useLibraryMediaUrl(itemId: string | null | undefined, mediaId: string | null | undefined) {
  const { data, error, isLoading } = useSWR<LibraryMediaUrl>(
    itemId && mediaId ? ["library-media", itemId, mediaId] : null,
    () => getLibraryMediaUrl(itemId as string, mediaId as string),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      dedupingInterval: 5 * 60_000,
      refreshInterval: 45 * 60_000,
      // Same reason as useAssetUrl: the presign expires in a hidden tab.
      refreshWhenHidden: true,
    }
  );
  return { media: data ?? null, error, isLoading: Boolean(itemId && mediaId) && isLoading };
}
